import { AuthProvider, useAuth } from "components/auth";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "ui/molecules/Errors/ErrorMessage";
import {
  HeaderContainer,
  HeaderHamburgerMenu,
  HeaderLogo,
  HeaderProfileNav,
} from "@thrivetribe/mvf.ui.organisms.header";
import MasterLayout from "ui/organisms/MasterLayout";
import { SidebarContainer, SidebarLinks, SidebarFaq, SidebarSocialMedia } from "ui/organisms/Sidebar";
import { faqLinks, profileNavLinks } from "configs/UrlConfig";
import { useState } from "react";
import { Footer } from "ui/organisms/Footer";

/**
 * A base component to generate/compose various error pages such as 404,500 etc.,
 * @param {number} statusCode -  status code
 */

export interface ErrorMessageProps {
  statusCode: number;
}

const Page404Error = () => {
  let { authService } = useAuth();
  let navigate = useNavigate();
  let [isSidebarOpen, setIsSitebarOpen] = useState<boolean>(true);

  let errorContent = {
    pageTitle: "Page not found",
    pageHeading: "404 Page not found",
    pageCopy: "Looks like the page you're after has left the pitch.",
    navigate: "/",
    errorImage: undefined,
  };

  if (authService.isAuthenticated()) {
    let authObj = authService.getAuthUser();
    let loggedInHeader = (
      <AuthProvider authService={authService}>
        <HeaderContainer>
          <HeaderHamburgerMenu isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSitebarOpen} />
          <HeaderLogo />
          <HeaderProfileNav links={profileNavLinks} user={authObj?.given_name + " " + authObj?.family_name} />
        </HeaderContainer>
      </AuthProvider>
    );
    return (
      <MasterLayout
        header={loggedInHeader}
        footer={<Footer />}
        sidebar={
          <SidebarContainer isSidebarOpen={isSidebarOpen}>
            <SidebarLinks isSidebarOpen={isSidebarOpen} setIsSitebarOpen={setIsSitebarOpen} />
            <SidebarSocialMedia />
            <SidebarFaq faqHeading="Got questions?" faqLinks={faqLinks} />
          </SidebarContainer>
        }
        body={
          <ErrorMessage
            pageTitle={errorContent.pageTitle}
            pageHeading={errorContent.pageHeading}
            pageCopy={errorContent.pageCopy}
          >
            <Button
              onClick={() => {
                navigate("/");
              }}
              variant="primary"
              color="primary"
            >
              Head home
              <ButtonArrow />
            </Button>
          </ErrorMessage>
        }
      />
    );
  }

  let loggedOutHeader = (
    <HeaderContainer>
      <HeaderLogo />
    </HeaderContainer>
  );

  return (
    <MasterLayout
      header={loggedOutHeader}
      body={
        <ErrorMessage
          pageTitle={errorContent.pageTitle}
          pageHeading={errorContent.pageHeading}
          pageCopy={errorContent.pageCopy}
        >
          <Button
            onClick={() => {
              authService.authorise();
            }}
            variant="secondary"
            style={{ width: "100%", justifyContent: "center", marginBottom: "12px" }}
          >
            Sign In
            <ButtonArrow />
          </Button>
          <Button
            onClick={() => {
              window.location.replace("https://manvfatfootball.org/");
            }}
            variant="primary"
            color="primary"
          >
            Head to MAN v FAT Football
            <ButtonArrow />
          </Button>
        </ErrorMessage>
      }
    />
  );
};

export default Page404Error;
